

export default function getProducts(room, austattung_produkt){

    const productList = [];
    const schaltbare = [];
    const normal = [];

    if(
        room.selectedEquipment["steckdosen"] !== undefined
        && room.selectedEquipment["steckdosen"] > 0
        && austattung_produkt["steckdosen"] !== undefined
    ){
        const p = { product: austattung_produkt["steckdosen"], count: room.selectedEquipment["steckdosen"] };
        productList.push(p);
        for (let i = 0; i<room.selectedEquipment["steckdosen"]; i++) { normal.push(p.product); }
    }
    if(
        room.selectedEquipment["schaltbare_steckdosen"] !== undefined
        && room.selectedEquipment["schaltbare_steckdosen"] > 0
        && austattung_produkt["steckdosen"] !== undefined
    ){
        const p = { product: austattung_produkt["steckdosen"], count: room.selectedEquipment["schaltbare_steckdosen"] };
        productList.push(p);
        for (let i = 0; i<room.selectedEquipment["schaltbare_steckdosen"]; i++) { schaltbare.push(p.product); }
    }
    // console.log('knx addSteckdosen returning', productList, schaltbare, normal, room.name, room.selectedEquipment)
    return { productList, schaltbare, normal };
}
